import FeedbackAuthentication from './FeedbackAuthentication';

function FeedbackAuthenticationContainer() {
  return <FeedbackAuthentication />;
}

export default FeedbackAuthenticationContainer;
